import { platformRoutes, resolvePlatformRequestUrl } from "../../common/platformRoutes";

type CartRequestUrlParams = {
   storeId: string;
   customerNumber: string;
};

export const resolveCartRequestUrl = ({ storeId, customerNumber }: CartRequestUrlParams) => {
   return resolvePlatformRequestUrl(platformRoutes.customerCartStoreAware, {
      storeId,
      customerNumber
   });
};
